<template>
  <row class="acts-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="act in acts" :key="act.id">
      <acts-item :act="act" :all="all" @open-act="openAct" />
    </i-col>
  </row>
</template>

<script>
import ActsItem from './acts-item'

export default {
  components: {
    ActsItem
  },
  props: ['acts', 'all'],
  methods: {
    openAct (payload) {
      this.$emit('open-act', payload)
    }
  }
}
</script>

<style>
</style>
